jQuery(document).ready(function($){
	$(".ic-blocks-tabs").each(function(){
		let currentTable = $(this);
		currentTable.find('>.ic-blocks-tabs-nav>.tab-title').each(function(index, item){
			$(item).click(function(){
				currentTable.find('>.wp-block-ic-blocks-tab.active').removeClass('active');
				currentTable.find('>.ic-blocks-tabs-nav>.tab-title.active').removeClass('active');
				currentTable.find('>.wp-block-ic-blocks-tab:nth('+index+')').addClass('active');
				$(item).addClass('active');
			})
		})
	})
})
